import { j as r } from "./kezios-design-system.esm172.js";
import { Card as n, Flex as i, Stack as o, Text as t } from "@mantine/core";
import { UserCard as f } from "./kezios-design-system.esm128.js";
import s from "./kezios-design-system.esm198.js";
import { IconArrowUpRight as y } from "./kezios-design-system.esm9.js";
import { Spacing as e } from "./kezios-design-system.esm135.js";
const N = ({
  image: c,
  category: l,
  title: m,
  subtitle: x,
  link: p,
  writtenBy: d,
  avatar: j,
  writtenAt: h,
  direction: a = "column",
  ...g
}) => /* @__PURE__ */ r.jsx(
  n,
  {
    shadow: "none",
    bg: "transparent",
    className: `${s.container} ${a === "row" ? s.row : ""}`,
    py: 0,
    ...g,
    children: /* @__PURE__ */ r.jsxs(i, { direction: a, gap: e.s6, children: [
      /* @__PURE__ */ r.jsx(n.Section, { className: `${s.imageContainer} ${s.section}`, children: c }),
      /* @__PURE__ */ r.jsx(n.Section, { className: `${s.textContainer} ${s.section}`, children: /* @__PURE__ */ r.jsxs(o, { gap: e.s6, children: [
        /* @__PURE__ */ r.jsxs(o, { gap: e.s2, children: [
          /* @__PURE__ */ r.jsx(t, { variant: "textSm.semibold", c: "primary.7", children: l }),
          /* @__PURE__ */ r.jsx("a", { className: s.link, href: p, children: /* @__PURE__ */ r.jsxs(i, { justify: "space-between", align: "center", gap: e.s2, children: [
            /* @__PURE__ */ r.jsx(
              t,
              {
                variant: "displayXs.semibold",
                c: "gray.9",
                truncate: a === "column" ? "end" : !1,
                children: m
              }
            ),
            /* @__PURE__ */ r.jsx(
              y,
              {
                style: { flexShrink: 0 },
                size: 24,
                color: "gray.9"
              }
            )
          ] }) }),
          /* @__PURE__ */ r.jsx(t, { variant: "textMd", c: "gray.6", children: x })
        ] }),
        /* @__PURE__ */ r.jsx(f, { name: d, subText: h, avatar: j })
      ] }) })
    ] })
  }
);
export {
  N as BlogCard
};
